// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__3x6vN","main":"Footer_main__ApreI","names":"Footer_names__1YoB6","commentMessage":"Footer_commentMessage__1Ot_w","email":"Footer_email__3TWWC"};